import React, { useEffect, useState } from 'react';
import './_Pad.scss'
import { useTranslation } from 'react-i18next';
import AssignResidentPad from './Assign/AssignResidentPad';
import ApiGo from '../../actions/ApiGo';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_BEDS_ARRAY } from '../../stores/reducer_beds';
import { ADD_RESIDENTS_ARRAY } from '../../stores/reducer_residentsArray';
import sortArray from '../../actions/sortArray'
import PopConfirm from '../popUp/PopConfirm';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../stores/reducer_add';
import { UPDATE_RSSI, UPDATE_VOLUME } from '../../stores/reducer_bedRealtime';
import RowPads from './RowPads';

const Pad = (props) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const mos = props.mos;
    const mos_rssi = mos?.rssi;
    const mos_volume = mos?.volume;

    // 打開分配畫面
    const [assignResOpen, setAssignResOpen] = useState(false);
    function toggleAssignRes() { setAssignResOpen(!assignResOpen) }
    const [padSelectedInfo, setPadSelectedInfo] = useState();
    // 配完受護者，重整
    const [refresh, setRefresh] = useState(false);
    function toggleRefresh() { setRefresh(!refresh) }
    // 準備map的html格式容器
    const [padbody, setPadbody] = useState([])
    // 正式執行
    // pop 確認視窗
    const [pop, setPop] = useState({
        open: false,
        content: "",
        parameter: [],
        callBack: null,
        title: ""
    });
    function togglePop() {
        setPop({
            open: false,
            content: "",
            parameter: [],
            callBack: null,
            title: ""
        })
    }
    const store_residents_array = useSelector(state => state.store_residents.orign_residents_array);
    const store_pads_array = useSelector(state => state.store_beds.beds_array);
    const rssiMap = useSelector(state => state.store_bedRealtime.rssi_map);
    const volumeMap = useSelector(state => state.store_bedRealtime.volume_map);

    useEffect(() => {
        if (refresh) {
            ApiGo.getBed().then(res => { dispatch(ADD_BEDS_ARRAY(res.beds)) })
            ApiGo.getResidents().then(res => { dispatch(ADD_RESIDENTS_ARRAY(res)) })
        }
        setRefresh(false)
    }, [refresh, dispatch]);
    //  ------------ redux ---------------------
    useEffect(() => {
        if (store_pads_array?.length > 0) {

            if (mos_rssi?.bedId) {

                dispatch(UPDATE_RSSI(mos_rssi))
            }
            if (mos_volume?.bedId) {
                dispatch(UPDATE_VOLUME(mos_volume))
            }
        }

    }, [mos_rssi, mos_volume, dispatch]);

    useEffect(() => {
        let _returnArr = [];
        let _beforeSortArr = [];
        let _pad = (props.institution !== "" && props.institution !== "全部單位") ? store_pads_array.filter(e => e.institution === props.institution) : store_pads_array;

        const idRankMap = Object.fromEntries(
            store_pads_array.map(pad => [pad.mac, pad.id])
        );

        _beforeSortArr = _pad.map(p => {
            const res = store_residents_array.find(res => res.id === p.resident_id);
            return {
                data: {
                    ...p,
                    rssi: rssiMap[p.mac] ?? null, //RSSI
                    volume: volumeMap[p.mac] ?? null, //音量
                    first_name: res?.first_name ?? null, //床號
                    last_name: res?.last_name ?? null, //受護者
                    padNumber: idRankMap[p.mac] ?? null  // ✅ 帶入編號
                }
            };
        });

        sortArray.desc_pad(_beforeSortArr, "first_name", "ch_char");
        sortArray.null_first(_beforeSortArr, "resident_id");

        _beforeSortArr.forEach((p_beforeData, index) => {
            let _div = <RowPads
                key={index}
                p={p_beforeData}
                index={index}
                toggleRefresh={toggleRefresh}
                toggleAssignRes={toggleAssignRes}
                setPadSelectedInfo={setPadSelectedInfo}
                setPop={setPop}
            />
            _returnArr.push(_div)
        });

        props.setReturnData(_returnArr.length)
        setPadbody(_returnArr)
    }, [t, store_residents_array, store_pads_array, props.institution, rssiMap, volumeMap]);

    function deleteSmartPad(mac) {               // 解綁，不是刪除
        setRefresh(false)
        return new Promise((resolve, reject) => {
            ApiGo.deleteSmart_pad(mac)
                .then(res => {
                    dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "dismiss_pad" }))
                    setRefresh(true)
                    resolve(res)
                })
                .catch(err => {
                    dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "dismiss_pad" }))
                    resolve(err)
                })
                .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
        })
    }

    return (
        <>
            {
                assignResOpen
                    ? <AssignResidentPad data={padSelectedInfo} hide={toggleAssignRes} toggleRefresh={toggleRefresh} />
                    : null
            }
            {
                pop.open
                    ? <PopConfirm
                        content={pop.content}
                        callBack={pop.callBack || deleteSmartPad}
                        title={pop.title || t("PAD.UNPAIR_SMART_PAD")}
                        hide={togglePop}
                        parameter={pop.parameter} />
                    : null
            }
            <div className="wrap-pad h-100">
                {/* 各分項title */}
                <div className="pad-row-head">
                    <div className='d-flex head'>
                        {/* RSSI */}
                        <div className="flex-grow-0 head-container"><div className="head">RSSI</div></div>
                        {/* 音量 */}
                        <div className="flex-grow-0 head-container"><div className="head">{t("NAV_BAR.VOLUME")}</div></div>
                        {/* 單位 */}
                        <div className="flex-grow-1 head-container"><div className="head">{t("GLOBAL.INSTITUTION")}</div></div>
                        {/* 編號 */}
                        <div className="flex-grow-1 head-container"><div className="head">{t("NAV_BAR.NUMBER")}</div></div>
                        {/* 床號 */}
                        <div className="flex-grow-1 head-container"><div className="head">{t("GLOBAL.BED_NO")}</div></div>
                        {/* 受護者 */}
                        <div className="flex-grow-1 head-container"><div className="head">{t("NAV_BAR.RESIDENTS")}</div></div>
                        {/* 智慧墊 */}
                        <div className="flex-grow-1 head-container"><div className="head">{t("NAV_BAR.PADS")}</div></div>
                        {/* 智慧墊配對 */}
                        <div className="flex-grow-1 head-container"><div className="head  ">{t("RESIDENTS.PAD_BOND")}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head invisible">#</div></div>
                    </div>
                </div>
                {/* 資料內容 */}
                <div className='reset-height h-90'>
                    {padbody}
                </div>
            </div>
        </>
    )
}

export default Pad